export default __webpack_public_path__ + "static/fab-e2a0bb9ce47749ab55cbaa5a6e95e787.jpg";